import { render, staticRenderFns } from "./TgpLink.vue?vue&type=template&id=64a331b2"
import script from "./TgpLink.vue?vue&type=script&lang=js"
export * from "./TgpLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports